// extracted by mini-css-extract-plugin
module.exports = {"LoyaltySettings":"LoyaltySettings___1cm4_","RGEmphasis":"RGEmphasis___i5jJN","link":"link___7bOfy"};